import SVG from 'components/SVG/SVG'
import * as T from 'components/SVG/types'

const UpCaret = (props: T.ISVGProps) => (
  <SVG
    {...props}
    viewBox="0 0 11 8"
    d="M9.325 0.912598L5.5 4.72926L1.675 0.912598L0.5 2.0876L5.5 7.0876L10.5 2.0876L9.325 0.912598Z"
  />
)

export default UpCaret
